import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Input,
  FormFeedback,
  Col,
} from "reactstrap";
import Select from "react-select";
import {
  getOperatorsUnitSelects,
  postImage,
  resourcesFiles,
  resourcesOperators,
  resourcesRoutes,
} from "../../../helpers/backend_helper";
import { getStorageCompany } from "../../../helpers/api_helper";
import { Alert } from "../../../helpers/alerts/alertHelper";
import Validate from "./Validate";
import ValidateFileHelper from "../../../helpers/ValidateFileHelper";

import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";
import { BLOOD_TYPES_ITEMS } from "../../../constants/bloodTypes";

const YESNO = [
  { name: "Si", id: true },
  { name: "No", id: false },
];

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
}) => {
  const company = getStorageCompany();
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState([]);
  const [units, setUnits] = useState([]);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      name: Yup.string().nullable(true).required("Requerido"),
      lname1: Yup.string().nullable(true).required("Requerido"),
      lname2: Yup.string().nullable(true).required("Requerido"),
      key: Yup.string().nullable(true).required("Requerido"),
      // Operador activado: el correo es su credencial de acceso al sistema.
      email: item.user_id
        ? Yup.string().email().required("Requerido")
        : Yup.string().email().nullable(true),
      unit_id: Yup.number().nullable(true).required("Requerido"),
      certificate: Yup.boolean(),
      key_name: Yup.string()
        .nullable(true)
        .when("certificate", {
          is: true,
          then: Yup.string().nullable(true).required("requerido"),
        }),
      date_procedure_license: Yup.date().nullable(true).required("Requerido"),
      date_expire_license: Yup.date().nullable(true).required("Requerido"),
      cellphone: Yup.string().nullable(true),
      nametag: Yup.string().nullable(true),
      route_id: Yup.string().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  const save = async (data) => {
    try {
      setLoading(true);
      const response = modal.update
        ? await resourcesOperators("put", data, data.id)
        : await resourcesOperators("post", data);
      responseAction(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.operator;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response.data.errors);
    }
  };

  useEffect(() => {
    if (authUser.profile_id != 3) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

  useEffect(() => {
    getOperatorsUnitSelects().then((response) => {
      setUnits(response.units);
    });
  }, []);

  useEffect(() => {
    if (item.photo_id)
      resourcesFiles("show", null, item.photo_id).then((response) => {
        setImage(response);
      });
  }, []);

  const fileValidate = (e) => {
    setErrors({});

    const validate = ValidateFileHelper(
      e.target.files[0],
      { required: true, type: "image", size: 1 },
      "Imagen de perfil"
    );
    if (validate != undefined) {
      setErrors(validate);
      return;
    }
    let nombre = "Archivo";
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.fileName = nombre[1] || nombre[0];
    reader.onloadend = function (name) {
      name = nombre[0];
      var base64data = reader.result;
      setItem({ ...item, file: base64data, type: e.target.files[0].type });
    };
  };

  async function encodeFileAsBase64URL(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("loadend", () => {
        resolve(reader.result);
      });
      reader.readAsDataURL(file);
    });
  }

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Agregar"} Operador
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              {authUser.profile_id == 2 && (
                <NibbleInput
                  md={12}
                  label="Ruta:"
                  fieldName="route_id"
                  fieldType="select"
                  selectItems={routes}
                  validation={validation}
                />
              )}

              <Col md={12}>
                <h5>Datos Personales</h5>
              </Col>
              <NibbleInput
                md={6}
                label="Nombre(s):"
                fieldName="name"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Apellido paterno:"
                fieldName="lname1"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Apellido materno:"
                fieldName="lname2"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Fecha de nacimiento:"
                fieldName="fec_nac"
                fieldType="date"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label={
                  item.user_id
                    ? "Correo electrónico (acceso al sistema):"
                    : "Correo electrónico:"
                }
                fieldName="email"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Teléfono móvil:"
                fieldName="cellphone"
                fieldType="number"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="CURP:"
                fieldName="curp"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Tipo Sanguineo:"
                fieldName="blood_type"
                fieldType="select"
                selectItems={BLOOD_TYPES_ITEMS}
                validation={validation}
              />
              <NibbleInput
                md={12}
                label="Comentarios:"
                fieldName="comments"
                fieldType="textarea"
                validation={validation}
              />

              <Col className="mt-3" md={12}>
                <h5 className="">Datos de Operador</h5>
              </Col>

              <NibbleInput
                md={6}
                label="Clave:"
                fieldName="key"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Unidad:"
                fieldName="unit_id"
                fieldType="select"
                selectItems={units ?? []}
                validation={validation}
                selectOptionLabel={(option) => `${option.number}`}
              />
              <NibbleInput
                md={6}
                label="Certificado:"
                fieldName="certificate"
                fieldType="select"
                selectItems={YESNO ?? []}
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Nombre de Certificado:"
                fieldName="key_name"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Fecha Trámite de Licencia:"
                fieldName="date_procedure_license"
                fieldType="date"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Fecha Vencimiento de Licencia:"
                fieldName="date_expire_license"
                fieldType="date"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Fecha de Ingreso:"
                fieldName="date_in"
                fieldType="date"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Fecha de Baja:"
                fieldName="date_out"
                fieldType="date"
                validation={validation}
              />

              <NibbleInput
                md={12}
                label="Motivo Baja:"
                fieldName="motive_out"
                fieldType="select"
                selectIsClearable={true}
                selectItems={[
                  { name: "Suspención" },
                  { name: "Renuncia voluntaria" },
                  { name: "Abandono de empleo" },
                  { name: "Abuso de confianza" },
                  { name: "Otro" },
                ]}
                selectOptionValue={(e) => e?.name ?? null}
                validation={validation}
              />

              <NibbleInput
                md={12}
                label="Foto operador:"
                fieldName="photo_id"
                fieldType="image"
                validation={validation}
                postFileFunction={postImage}
                itemFile={image}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
